/**
 * Cookie 条入场、页面 padding-bottom 过渡（可与条同频）。
 * adv-cookie 条上 `cookieAnimation` 多为 2s，留白与条同频时可对齐该量级。
 */
export const COOKIE_LAYOUT_DURATION_MS = 1500;

export const COOKIE_LAYOUT_DURATION_CSS = `${COOKIE_LAYOUT_DURATION_MS / 1000}s`;

/**
 * 协议区补滚须明显短于 Cookie 条入场（约 2s），在条未滑完前完成滚动。
 */
export const COOKIE_SCROLL_DURATION_MS = 500;
